export default "__VITE_ASSET__CWIy4GiS__"